import React, { useRef, useEffect, useState } from "react";
import styles from "./style.module.css";

import { ButtonGroup, Button, Icon, Accordion } from "aible";
import { Modal, Popover, OverlayTrigger } from "react-bootstrap";
import Select from "react-select";

import { useSelector, useDispatch } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";

import { LineInput } from "components/Inputs/LineInput";
import Tooltip from "components/Inputs/Tooltip";

const TestChatAppSelector = (props = {}) => {
  const { className, menuPlacement, isDisabled, ...retProps } = props;

  const dispatch = useDispatch();

  const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));

  const isAZTestApp = chatApp?.wizard?.isChatApp && chatApp?.wizard?.isAZTestApp;
  const testOptions = useSelector((state) => chatAppReducer.getAZTestOptions(state, chatApp?.id));
  const testSeed = useSelector((state) => chatGPTReducer.getAZTestSeed(state));
  const selectedOption = testOptions.find((o) => {
    if (testSeed < o.max && testSeed > o.min) {
      return true;
    }
    return false;
  });

  const updateAZTestSeed = (val) => dispatch(chatAppReducer.selectAZTestApp(val));

  if (!isAZTestApp) {
    return <React.Fragment />;
  }

  return (
    <React.Fragment>
      <div className={styles.testChatAppSelector + " " + (className ? className : "")} {...retProps}>
        <Select
          options={testOptions}
          value={selectedOption}
          onChange={(val) => updateAZTestSeed(val?.value)}
          placeholder={"Select Chat App"}
          menuPlacement={menuPlacement ?? "bottom"}
          isDisabled={isDisabled}
          isSearchable
        />
      </div>
    </React.Fragment>
  );
};

export default TestChatAppSelector;
